module.exports = __webpack_public_path__ + "media/application/images/projects/images/ireland-850ff0ddbb9205373c08cc80806da8a5.jpg";